let headline = [
    {
        path: '/headline/part',
        name: 'list',
        component: () => import('@/views/headline/part/list.vue'),
        meta: {keepAlive: true, parentPath: 'headline'},
    },
    {
        path: '/headline/part/edit',
        name: 'edit',
        component: () => import('@/views/headline/part/edit.vue'),
        meta: {keepAlive: true, parentPath: 'headline'},
    },
    {
        path: '/headline/section/edit',
        name: 'edit',
        component: () => import('@/views/headline/section/edit.vue'),
        meta: {keepAlive: true, parentPath: 'headline'},
    },
    {
        path: '/headline/section',
        name: 'list',
        component: () => import('@/views/headline/section/list.vue'),
        meta: {keepAlive: true, parentPath: 'headline'},
    }
    
    
]
export default headline


// WEBPACK FOOTER //
// ./src/router/headline.js